import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/HE.png'
import _imports_1 from '@/assets/icons/EN.png'
import _imports_2 from '@/assets/icons/RU.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-a3fcee40")

_pushScopeId("data-v-a3fcee40")
const _hoisted_1 = {
  class: "container popup-container2",
  id: "document-share"
}
const _hoisted_2 = { class: "w-100 document-share-content" }
const _hoisted_3 = { class: "document-share-title" }
const _hoisted_4 = { class: "share-document-block" }
const _hoisted_5 = {
  key: 0,
  class: "desktop-lang-block"
}
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "document-share-top-row" }
const _hoisted_8 = { class: "label-doc-share" }
const _hoisted_9 = { class: "locale-block" }
const _hoisted_10 = { class: "mr-18 label-doc-share" }
const _hoisted_11 = { class: "lang-locale-block" }
const _hoisted_12 = {
  key: 0,
  class: "opened-locale-block"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "language-image",
  src: _imports_0
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "language-image",
  src: _imports_1
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "language-image",
  src: _imports_2
}, null, -1)
const _hoisted_16 = { class: "share-msg-text" }
const _hoisted_17 = { class: "desktop-lang-block-second-row" }
const _hoisted_18 = { class: "mr-18 label-doc-share desktop-lang-block-second-row-title" }
const _hoisted_19 = {
  key: 0,
  style: {"width":"143px"}
}
const _hoisted_20 = {
  key: 1,
  class: "desktop-lang-block-second-row-langItems"
}
const _hoisted_21 = {
  key: 1,
  class: "row-delimiter first-row-delimiter"
}
const _hoisted_22 = { class: "share-item-row" }
const _hoisted_23 = { style: {"padding-inline-end":"0"} }
const _hoisted_24 = {
  class: "cbx w-100",
  for: "agree-cbx"
}
const _hoisted_25 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", {
  for: "agree-cbx",
  style: {"display":"inline"}
}, [
  /*#__PURE__*/_createVNode("span", { class: "col-2 m-0 checkbox-item" }, [
    /*#__PURE__*/_createVNode("svg", {
      width: "12px",
      height: "10px",
      viewBox: "0 0 12 10"
    }, [
      /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    ])
  ])
], -1)
const _hoisted_27 = { class: "checkbox-label" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "label-doc-share" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "label-doc-share" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "row-delimiter second-row-delimiter" }, null, -1)
const _hoisted_33 = { class: "share-item-row share-item-row-sms" }
const _hoisted_34 = { style: {"padding-inline-end":"0"} }
const _hoisted_35 = {
  class: "cbx w-100",
  for: "agree-cbx2"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("label", {
  for: "agree-cbx2",
  style: {"display":"inline"}
}, [
  /*#__PURE__*/_createVNode("span", { class: "col-2 m-0 checkbox-item" }, [
    /*#__PURE__*/_createVNode("svg", {
      width: "12px",
      height: "10px",
      viewBox: "0 0 12 10"
    }, [
      /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    ])
  ])
], -1)
const _hoisted_37 = { class: "checkbox-label" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "label-doc-share" }
const _hoisted_40 = { class: "document-share-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('title.share_document')), 1),
      _createVNode("div", _hoisted_4, [
        (_ctx.sendSms || _ctx.sendEmail)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('label.message')), 1),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('label.doc_language')), 1),
                    _createVNode("div", _hoisted_11, [
                      (_ctx.openedLocaleBlock)
                        ? (_openBlock(), _createBlock("div", _hoisted_12, [
                            _createVNode("div", {
                              class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'he-IL' }]
                            }, [
                              _createVNode("img", {
                                class: "language-image",
                                src: _imports_0,
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLang('he-IL')))
                              })
                            ], 2),
                            _createVNode("div", {
                              class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'en-US' }]
                            }, [
                              _createVNode("img", {
                                class: "language-image",
                                src: _imports_1,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLang('en-US')))
                              })
                            ], 2),
                            _createVNode("div", {
                              class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'ru-RU' }]
                            }, [
                              _createVNode("img", {
                                class: "language-image",
                                src: _imports_2,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeLang('ru-RU')))
                              })
                            ], 2)
                          ]))
                        : (_openBlock(), _createBlock("div", {
                            key: 1,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openedLocaleBlock = !_ctx.openedLocaleBlock)),
                            class: "desktop-language-select"
                          }, [
                            (_ctx.locale == 'he-IL')
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'he-IL' }]
                                }, [
                                  _hoisted_13
                                ], 2))
                              : _createCommentVNode("", true),
                            (_ctx.locale == 'en-US')
                              ? (_openBlock(), _createBlock("div", {
                                  key: 1,
                                  class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'en-US' }]
                                }, [
                                  _hoisted_14
                                ], 2))
                              : _createCommentVNode("", true),
                            (_ctx.locale == 'ru-RU')
                              ? (_openBlock(), _createBlock("div", {
                                  key: 2,
                                  class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'ru-RU' }]
                                }, [
                                  _hoisted_15
                                ], 2))
                              : _createCommentVNode("", true)
                          ]))
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _withDirectives(_createVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.message = $event)),
                    class: "bookit-input w100",
                    rows: "5"
                  }, null, 512), [
                    [_vModelText, _ctx.message]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('label.doc_language')), 1),
                (!_ctx.openedLocaleBlock)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _createVNode("div", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openedLocaleBlock = !_ctx.openedLocaleBlock)),
                        class: "desktop-lang-block-second-row-title-selected-lang"
                      }, [
                        (_ctx.locale == 'he-IL')
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'he-IL' }]
                            }, [
                              _createVNode("img", {
                                class: "language-image",
                                src: _imports_0,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeLang('he-IL')))
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.locale == 'en-US')
                          ? (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'en-US' }]
                            }, [
                              _createVNode("img", {
                                class: "language-image",
                                src: _imports_1,
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeLang('en-US')))
                              })
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.locale == 'ru-RU')
                          ? (_openBlock(), _createBlock("div", {
                              key: 2,
                              class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'ru-RU' }]
                            }, [
                              _createVNode("img", {
                                class: "language-image",
                                src: _imports_2,
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeLang('ru-RU')))
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_20, [
                      _createVNode("div", {
                        class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'he-IL' }]
                      }, [
                        _createVNode("img", {
                          class: "language-image",
                          src: _imports_0,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeLang('he-IL')))
                        })
                      ], 2),
                      _createVNode("div", {
                        class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'en-US' }]
                      }, [
                        _createVNode("img", {
                          class: "language-image",
                          src: _imports_1,
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeLang('en-US')))
                        })
                      ], 2),
                      _createVNode("div", {
                        class: ["my-auto text-c locale-item", { 'active-locale': _ctx.locale == 'ru-RU' }]
                      }, [
                        _createVNode("img", {
                          class: "language-image",
                          src: _imports_2,
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeLang('ru-RU')))
                        })
                      ], 2)
                    ]))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.sendSms || _ctx.sendEmail)
          ? (_openBlock(), _createBlock("div", _hoisted_21))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _withDirectives(_createVNode("input", {
              class: "inp-cbx",
              name: "agree-cbx",
              id: "agree-cbx",
              type: "checkbox",
              value: "true",
              style: {"display":"none"},
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.sendEmail = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.sendEmail]
            ]),
            _createVNode("label", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('label.email')), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_28, [
            _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('label.receiver')), 1),
            _withDirectives(_createVNode("input", {
              class: "bookit-input order-input w100",
              type: "text",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.emailReceiver = $event))
            }, null, 512), [
              [_vModelText, _ctx.emailReceiver]
            ])
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('label.email_subject')), 1),
            _withDirectives(_createVNode("input", {
              class: "bookit-input order-input w100",
              type: "text",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.emailSubject = $event))
            }, null, 512), [
              [_vModelText, _ctx.emailSubject]
            ])
          ])
        ]),
        _hoisted_32,
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _withDirectives(_createVNode("input", {
              class: "inp-cbx",
              name: "agree-cbx2",
              id: "agree-cbx2",
              type: "checkbox",
              value: "true",
              style: {"display":"none"},
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.sendSms = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.sendSms]
            ]),
            _createVNode("label", _hoisted_35, [
              _createVNode("div", null, [
                _hoisted_36,
                _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('label.sms')), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_38, [
            _createVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('label.receiver')), 1),
            _withDirectives(_createVNode("input", {
              class: "bookit-input order-input w100",
              type: "text",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.smsReceiver = $event))
            }, null, 512), [
              [_vModelText, _ctx.smsReceiver]
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_40, [
        _createVNode("div", null, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.send())),
            class: "share-document-btn"
          }, _toDisplayString(_ctx.$t('button.send')), 1)
        ]),
        _createVNode("div", null, [
          _createVNode("button", {
            class: "close-document-btn",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.close())),
            type: "button"
          }, _toDisplayString(_ctx.$t('button.close')), 1)
        ])
      ])
    ])
  ]))
})